import { PathItem } from '../../data/builders/path_item_builder';
import { PathTask } from '../../data/builders/path_task_builder';

export class TipCardController {
  private task: PathTask;
  private item: PathItem;

  constructor(private $state: ng.ui.IStateService) {}

  get stateUri(): string {
    const params = {
      eventId: this.task.event,
      repeatedBy: this.task.repeated_by
    };
    return `my.todos.tip(${JSON.stringify(params)})`;
  }
}
export class TipCardComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/tip_card/tip_card.html';
  public controller: any = TipCardController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    task: '<',
    item: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/tip_card/tip_card.ts